export { ContextMenuModule } from './ngx-contextmenu';
export * from './contextMenu.component';
export * from './contextMenu.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-contextmenu/lib/index.js
// module id = ./node_modules/ngx-contextmenu/lib/index.js
// module chunks = vendor